import { type JSX } from "react";

import { Menu as BaseMenu } from "@base-ui/react/menu";

import { MenuContext, makeMenuContext, useMenuContext } from "./Menu.context";
import type { MenuProps } from "./Menu.types";

function Menu({
  align,
  side,
  arrow,
  size,
  variant,
  children,
  ...props
}: MenuProps): JSX.Element {
  // A Menubar holds one Menu per title, so what the bar decided has to reach
  // them: a root falls back to the context around it rather than to the
  // defaults, and only what it was given overrides.
  const outer = useMenuContext();

  return (
    <MenuContext.Provider
      value={makeMenuContext({
        size: size ?? outer.size,
        variant: variant ?? outer.variant,
        align: align ?? outer.align,
        side: side ?? outer.side,
        arrow: arrow ?? outer.arrow,
      })}
    >
      <BaseMenu.Root data-slot="menu" {...props}>
        {children}
      </BaseMenu.Root>
    </MenuContext.Provider>
  );
}

export { Menu };
